let firebaseConfig = {};

if (process.env.REACT_APP_ENV === 'preprod') {
    firebaseConfig = require('./firebase.preprod').firebaseConfig;
} else {
    firebaseConfig = require('./firebase.prod').firebaseConfig;
}

export { firebaseConfig };